import React, { useState, useEffect } from "react";
import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import api from "../../utils/api";
import { useDispatch, useSelector } from "react-redux";

// import {Link } from 'react-router-dom';
import "./Search.css";
import SearchedData from "./SearchedData";
import { Box } from "@mui/material";

export const Search = ({ searchedText }) => {
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const [searchType, setSearchType] = useState();

  useEffect(() => {
    console.log("user at hiroshima", currentUser?.userRole, searchType);
    setTimeout(() => {
      let st =
        currentUser?.userRole?.toLocaleLowerCase() ==
        "fypSupervisor".toLocaleLowerCase()
          ? "New FYPs"
          : currentUser?.userRole.toLocaleLowerCase() ==
            "alumni".toLocaleLowerCase()
          ? "Questions"
          : currentUser?.userRole.toLocaleLowerCase() ==
            "hostelOwner".toLocaleLowerCase()
          ? "Hostels"
          : currentUser?.userRole.toLocaleLowerCase() ==
            "companyRepresentative".toLocaleLowerCase()
          ? "Internships"
          : currentUser?.userRole.toLocaleLowerCase() ==
            "sscOfficer".toLocaleLowerCase()
          ? "Scholarships"
          : "Questions";
      setSearchType(st);
      console.log("st", st);
    }, 500);
  }, [currentUser]);
  const [data, setData] = useState([]);
  const [searchedData, setSearchedData] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    // console.log("searched Text", searchedText);

    setSearchText(searchedText);
  }, [searchedText]);
  useEffect(() => {
    setSearchedData([]);
    setData([]);
    // console.log("searchType", searchType);
    if (searchType == "Questions") {
      console.log("running questions");
      api
        .get("/questions")
        .then((res) => {
          // console.log("questions", res.data);
          setData(res.data);
        })
        .catch((err) => console.log);
    }
    if (searchType == "Projects") {
      console.log("running projects");
      api
        .get("/projects")
        .then((res) => {
          console.log("projects", res.data);
          setData(res.data);
        })
        .catch((err) => console.log);
    }
    if (searchType == "Scholarships") {
      console.log("running scholarships");
      api
        .get("/scholarships")
        .then((res) => {
          // console.log("scholarships", res.data);
          setData(res.data);
        })
        .catch((err) => console.log);
    }
    if (searchType == "Internships") {
      console.log("running internships");
      api
        .get("/internships")
        .then((res) => {
          console.log("internships", res.data);
          setData(res.data);
        })
        .catch((err) => console.log);
    }
    if (searchType == "Hostels") {
      console.log("running hostels");
      api
        .get("/hostels")
        .then((res) => {
          // console.log("hostels", res.data);
          setData(res.data);
        })
        .catch((err) => console.log);
    }
    if (searchType == "New FYPs") {
      console.log("running fyps");
      console.log("running");
      api
        .get("/FYPs/new")
        .then((res) => {
          // console.log("new FYPs", res.data);
          setData(res.data);
        })
        .catch((err) => console.log);
    }
    if (searchType == "Already Created FYPs") {
      console.log("running created fyps");
      api
        .get("/FYPs/already-created")
        .then((res) => {
          // console.log("already created fyps", res.data);
          setData(res.data);
        })
        .catch((err) => console.log);
    }
  }, [searchType]);
  useEffect(() => {
    // console.log("searchText", searchText);
    setSearchedData([]);
    let array = [];
    if (data?.length > 0) {
      if (searchType == "Questions") {
        data.map((d) => {
          let flag = false;
          if (d?.question?.toLowerCase().search(searchText) != -1) {
            flag = true;
          }
          if (d?.tags?.length > 0) {
            d.tags.forEach((t) => {
              if (t?.toLowerCase().search(searchText) != -1) {
                flag = true;
              }
            });
          }
          if (flag == true) {
            array.push(d);
          }
        });
      }
      if (searchType == "Projects") {
        data.map((d) => {
          let flag = false;
          if (
            d?.title?.toLowerCase().search(searchText) != -1 ||
            d?.projectType?.toLowerCase().search(searchText) != -1 ||
            d?.description?.toLowerCase().search(searchText) != -1 ||
            d?.paymentBy?.toLowerCase().search(searchText) != -1 ||
            d?.price?.toLowerCase().search(searchText) != -1 ||
            d?.projectType?.toLowerCase().search(searchText) != -1 ||
            d?.tech_used?.toLowerCase().search(searchText) != -1
          ) {
            flag = true;
          }

          if (d?.skills?.length > 0) {
            d.skills.forEach((t) => {
              if (t?.toLowerCase().search(searchText) != -1) {
                flag = true;
              }
            });
          }
          if (flag == true) {
            array.push(d);
          }
        });
      }
      if (searchType == "Scholarships") {
        data.map((d) => {
          let flag = false;
          if (
            d?.title?.toLowerCase().search(searchText) != -1 ||
            d?.country?.toLowerCase().search(searchText) != -1 ||
            d?.description?.toLowerCase().search(searchText) != -1 ||
            d?.scholarshipFor?.toLowerCase().search(searchText) != -1 ||
            d?.scholarshipType?.toLowerCase().search(searchText) != -1 ||
            d?.duration?.toLowerCase().search(searchText) != -1
          ) {
            flag = true;
          }

          if (flag == true) {
            array.push(d);
          }
        });
      }
      if (searchType == "Internships") {
        data.map((d) => {
          let flag = false;
          if (
            d?.generalData?.companyName?.toLowerCase().search(searchText) !=
              -1 ||
            d?.generalData?.description?.toLowerCase().search(searchText) !=
              -1 ||
            d?.generalData?.internshipTitle?.toLowerCase().search(searchText) !=
              -1 ||
            d?.generalData?.internshipType?.toLowerCase().search(searchText) !=
              -1
          ) {
            flag = true;
          }

          if (flag == true) {
            array.push(d);
          }
        });
      }
      if (searchType == "Hostels") {
        data.map((d) => {
          let flag = false;
          console.log(
            "test 1",
            d?.generalData?.description?.toLowerCase().search(searchText) != -1
          );
          if (
            d?.generalData?.hostelName?.toLowerCase().search(searchText) !=
              -1 ||
            d?.generalData?.billsIncluded?.toLowerCase().search(searchText) !=
              -1 ||
            d?.generalData?.city?.toLowerCase().search(searchText) != -1 ||
            d?.generalData?.estimatedRent?.toLowerCase().search(searchText) !=
              -1 ||
            d?.generalData?.hostelAddress?.toLowerCase().search(searchText) !=
              -1 ||
            d?.generalData?.hostelCategory?.toLowerCase().search(searchText) !=
              -1 ||
            d?.generalData?.hostelCondition?.toLowerCase().search(searchText) !=
              -1 ||
            d?.generalData?.hostelDetails?.toLowerCase().search(searchText) !=
              -1 ||
            d?.generalData?.tagsText?.toLowerCase().search(searchText) != -1 ||
            d?.generalData?.state?.toLowerCase().search(searchText) != -1 ||
            d?.generalData?.rentPeriod?.toLowerCase().search(searchText) !=
              -1 ||
            d?.generalData?.tagsText?.toLowerCase().search(searchText) != -1
          ) {
            flag = true;
          }

          if (d?.facilities?.length > 0) {
            d.facilities.forEach((t) => {
              if (t?.toLowerCase().search(searchText) != -1) {
                flag = true;
              }
            });
          }

          if (flag == true) {
            array.push(d);
          }
        });
      }
      if (searchType == "New FYPs") {
        data.map((d) => {
          let flag = false;
          if (
            d?.title?.toLowerCase().search(searchText) != -1 ||
            d?.techUsed?.toLowerCase().search(searchText) != -1 ||
            d?.projectType?.toLowerCase().search(searchText) != -1 ||
            d?.description?.toLowerCase().search(searchText) != -1
          ) {
            flag = true;
          }

          if (flag == true) {
            array.push(d);
          }
        });
      }
      if (searchType == "Already Created FYPs") {
        data.map((d) => {
          let flag = false;
          if (
            d?.title?.toLowerCase().search(searchText) != -1 ||
            d?.techUsed?.toLowerCase().search(searchText) != -1 ||
            d?.projectType?.toLowerCase().search(searchText) != -1 ||
            d?.description?.toLowerCase().search(searchText) != -1
          ) {
            flag = true;
          }

          if (flag == true) {
            array.push(d);
          }
        });
      }
    }
    setSearchedData(array);
    console.log("search result data=>", array);
    console.log(" data=>", data);
    console.log("search type=>", searchType);
    console.log("search text=>", searchText);
  }, [searchText, searchType, data]);
  useEffect(() => {
    // console.log("searched data=>", searchedData);
  }, [searchedData]);
  return (
    <Box>
      {/* <Header />
      <Menunav /> */}
      <Box className="row">
        {/* <Box className="col-md-2 col-0">
          <Sidebar />
        </Box> */}
        <Box className="col-md-12 col-12">
          <Box className="container mt-5 mb-3">
            {/* <Box className="row search-box col-lg-6 col-md-8 col-12 m-auto bg-gray-100 bg-opacity-50 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 leading-8 transition-colors duration-200 ease-in-out">
              <Box className="col-1 text-center">
                <span className="fa fa-search"></span>
              </Box>
              <Box className="col-11">
                <input
                  type="text"
                  placeholder="Search"
                  name="name"
                  onChange={(e) => setSearchText(e.target.value?.toLowerCase())}
                  className=" bg-gray-100 bg-opacity-50  text-base w-full outline-none text-gray-700 leading-8 transition-colors duration-200 ease-in-out"
                />
              </Box>
            </Box> */}
            <Box
              className="sorting__area mt-3   flex justify-right"
              sx={{ marginBottom: "40px" }}
            >
              <h6>Search DataType</h6>
              <select
                className="border border-gray ml-4"
                name="sortingOptions"
                id="sortingOptions"
                onChange={(e) => setSearchType(e.target.value)}
                defaultValue={searchType}
              >
                {(currentUser?.userRole?.toLocaleLowerCase() == "student" ||
                  currentUser?.userRole?.toLocaleLowerCase() == "alumni" ||
                  currentUser?.isAdmin) && (
                  <>
                    <option value="Questions">Questions</option>
                  </>
                )}

                {(currentUser?.userRole?.toLocaleLowerCase() == "student" ||
                  currentUser?.userRole?.toLocaleLowerCase() ==
                    "fypsupervisor" ||
                  currentUser?.isAdmin) && (
                  <>
                    <option value="New FYPs">New FYPs</option>
                    <option value="Already Created FYPs">
                      Already Created FYPs
                    </option>
                  </>
                )}

                {(currentUser?.userRole?.toLocaleLowerCase() == "student" ||
                  currentUser?.userRole?.toLocaleLowerCase() == "hostelowner" ||
                  currentUser?.isAdmin) && (
                  <>
                    <option value="Hostels">Hostels</option>
                  </>
                )}

                {(currentUser?.userRole?.toLocaleLowerCase() == "student" ||
                  currentUser?.userRole?.toLocaleLowerCase() == "alumni" ||
                  currentUser?.isAdmin) && (
                  <>
                    <option value="Projects">Projects</option>
                  </>
                )}

                {/* <MenuHeading>Authentication</MenuHeading> */}
                {(currentUser?.userRole?.toLocaleLowerCase() == "student" ||
                  currentUser?.userRole?.toLocaleLowerCase() == "sscofficer" ||
                  currentUser?.isAdmin) && (
                  <>
                    <option value="Scholarships">Scholarships</option>
                  </>
                )}

                {(currentUser?.userRole?.toLocaleLowerCase() == "student" ||
                  currentUser?.userRole?.toLocaleLowerCase() == "alumni" ||
                  currentUser?.userRole?.toLocaleLowerCase() ==
                    "companyrepresentative" ||
                  currentUser?.isAdmin) && (
                  <>
                    <option value="Internships">Internships</option>
                  </>
                )}
              </select>
            </Box>
            <SearchedData
              searchType={searchType}
              searchText={searchText}
              searchedData={searchedData}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
